// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"31":"laporandetail","387":"registerdetail","580":"laporan","962":"home","970":"monitoringdetail"}[chunkId] + "." + {"31":"3a3e0767","387":"8bc4f18d","580":"3a3e0767","962":"4d572ddf","970":"2750874e"}[chunkId] + ".css";
};